module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-18.273f1037.png";